import moment from 'moment'
const GRADES = [
  'F',
  'D-',
  'D',
  'D+',
  'CD',
  'C-',
  'C',
  'C+',
  'BC',
  'B-',
  'B',
  'B+',
  'AB',
  'A-',
  'A',
  'A+'
]

export function trim (str) {
  return str.replace(/ /g,'')
}
export function isGradePassed (grade = 'A+', compareGrade = 'F') {
  const gradeIndex = GRADES.indexOf(trim(grade).toUpperCase())
  const testGrade = GRADES.indexOf(trim(compareGrade).toUpperCase())

  return gradeIndex >= testGrade
}

export function yearsFromNow (date) {
  return moment().diff( moment(date), 'years' )
}

export function daysFromYearsAgo (date, years) {
  return moment(date).diff(moment().subtract(years, 'years'), 'days')
}

export function handleize (str) {
  str = str.toLowerCase();

  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
  }

  if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
  }

  return str
}

export function empty( val ) {

  // test results
  //---------------
  // []        true, empty array
  // {}        true, empty object
  // null      true
  // undefined true
  // ""        true, empty string
  // ''        true, empty string
  // 0         false, number
  // true      false, boolean
  // false     false, boolean
  // Date      false
  // function  false

      if (val === undefined)
      return true;

  if (typeof (val) == 'function' || typeof (val) == 'number' || typeof (val) == 'boolean' || Object.prototype.toString.call(val) === '[object Date]')
      return false;

  if (val == null || val.length === 0)        // null or 0 length array
      return true;

  if (typeof (val) == "object") {
      // empty object

      var r = true;

      for (var f in val)
          r = false;

      return r;
  }

  return false;
}

export function isQuarterCollege ({ college_term_system = '' }) {
  return handleize(college_term_system) === 'quarter'
}

export function filterZeroArrays (arr = []) {
  return arr.filter((el) => el !== 0)
}

export function addSemesterCreditsToQuarter (course) {
  const { quarter_credits = '', lab_quarter_credits = '' } = course
  const quarterCredits = parseFloat(quarter_credits)
  const labQuarterCredits = parseFloat(lab_quarter_credits)
  return {
    ...course,
    isQuarter: true,
    course_credits: isNaN(quarterCredits) ? 0 : quarterCredits / 1.5,
    lab_credits: isNaN(labQuarterCredits) ? 0 : labQuarterCredits / 1.5
  }
}

export function sortArrayByDate (data = [], dateKey = null) {
  if (!dateKey) return data
  const newData = [].concat(data)
  newData.sort((a, b) => {
    return moment(a[dateKey]).valueOf() <= moment(b[dateKey]).valueOf() ? 1 : -1
  })
  return newData
}
// Returns all valid user courses sorted from latest to oldest

export function getCoursesFromColleges (userColleges = [], semesterStatus = 'completed') {
  if (userColleges && userColleges.length) {
    let COURSES = []
    const colleges = userColleges.concat([])
    colleges.sort((a, b) => {
      return moment(a.college_graduation_date).valueOf() <= moment(b.college_graduation_date).valueOf() ? 1 : -1
    })
    const allSemesters = colleges.reduce((sems, college) => {
      const { semesters } = college
      const isQuarter = isQuarterCollege(college)
      return sems.concat(
        semesters.map((sem) => {
          sem.isQuarter = isQuarter
          return sem
        })
      )
    }, [])

    allSemesters.sort((a, b) => {
      if (!a.semester_year || !b.semester_year) return -1
      return moment(a.semester_year).valueOf() <= moment(b.semester_year).valueOf() ? 1 : -1
    })

    allSemesters.forEach((sem) => {
      let newCourses = sem.courses
      if (sem.isQuarter) {
        newCourses = newCourses.map(addSemesterCreditsToQuarter)
      }

      if (semesterStatus === 'any') {
        COURSES = [...COURSES, ...newCourses]
        return COURSES
      }
      if (
        sem.semester_completion_status &&
        handleize(sem.semester_completion_status) === handleize(semesterStatus)
      ) {
        COURSES = [...COURSES, ...newCourses]
      }
    })
    return COURSES.filter((c) => !isWithdrawnCourse(c))
  }
  return []
}

export function getCreditsValue (course_credits) {
  if (!empty(course_credits)) {
    const credits = parseFloat(course_credits)
    if (isNaN(credits)) return 0
    return credits
  }
  return 0
}

export function coursesWithCreditsTotal (courses, total = 0, courseFilter = (n) => n) {
  const addedCourses = []
  let creditTotal = 0
  for (let index = 0; index < courses.length; index++) {
    if (creditTotal >= total) {
      break
    }
    const course = courses[index]
    if (!courseFilter(course)) {
      continue;
    }
    const { course_credits = '', lab_credits = '' } = course
    creditTotal += getCreditsValue(course_credits)
    creditTotal += getCreditsValue(lab_credits)
    addedCourses.push(course)
  }
  if (creditTotal >= total) return addedCourses
  return []
}

export const formatPrice = (num, fraction = 0) => {
  return parseFloat(Number(num) / 100).toLocaleString('en-EN', {
    maximumFractionDigits: 2,
    minimumFractionDigits: fraction
  })
}

export const isWithdrawnCourse = (course) => {
  return handleize(course.course_grade) === 'w'
}

export const totalCourseCredits = (course, isQuarter = false) => {
  let credits = isQuarter ? Number(course.quarter_credits) : Number(course.course_credits)
  if (course.course_lab == 'true' && !empty(course['lab_credits'])) {
    const labcredits = isQuarter ? Number(course['lab_quarter_credits']) : Number(course['lab_credits'])
    if (!isNaN(labcredits)) {
      credits += labcredits
    }
  }
  return isNaN(credits) ? 0 : credits
}

export const getTotalLoggedHours = (experience, minimumDuration = 0) => {
  let totalHours = 0
  if (!experience) return 0
  const exp = Object.values(experience)
  exp.forEach(({ logged_hours = {} }) => {
    const hours = Object.values(logged_hours)
    totalHours = hours.reduce((t, { hours, date, from_date }) => {
      const dateToCheck = empty(date) ? from_date : date
      const durationWithinDays = moment().diff( moment(dateToCheck), 'days' )
      if (minimumDuration && durationWithinDays > (minimumDuration * 365)) return t
      const h = Number(hours)
      if (isNaN(h)) return t
      return t + h
    }, totalHours)
  })
  if (isNaN(totalHours)) return 0
  return totalHours
}

export const removeEmpty = (obj) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
    else if (obj[key] === undefined) delete obj[key];
  });
  return obj;
}



// WEBPACK FOOTER //
// ./src/lib/utils.js